module.exports = __webpack_public_path__ + "a84e7dd6bf8b7e6ed57fbd3f1a7ef8de.svg";